








































































import { Component, Vue } from "vue-property-decorator";
import KbmViewPanel from "@/components/main/Precheck/KbmViewPanel.vue";
import { v4 as uuidv4 } from "uuid";
import { InsuranceCard } from "@/services/index.defs";
import { CalcState, CalcStatus } from "@/models/Models";
import BadEnd from "_C/main/Finish/BadEnd.vue";
import { DefaultCopy } from "_P/copyobj";
import { GaHelper } from "@/core/helpers/ga";
import PrecheckLoader from "./PrecheckLoader.vue";
import { sortCalcsByPriority } from '@/utils/sortCalcsByPriority';
import { EventName, sendPostMessageEvent } from '@/utils/analyticMessages';

const readyStatuses = [
    CalcStatus.CalcSuccess,
    CalcStatus.CalcFail,
    CalcStatus.NeedToSelectCar
];
const isReady = calc => readyStatuses.includes(calc.status);

@Component({ components: { BadEnd, KbmViewPanel, PrecheckLoader } })
export default class PrecheckCalcs extends Vue {
    get isLoading() {
        const icCount = this.$store.direct.state.dicti.providers.length;
        const allReady = this.calcs.filter(isReady).length == icCount;
        return !allReady;
    }
    async created() {
        await this.init();
    }
    async init() {
        console.log("runPrecalc start");
        if (!this.cardHaveChanges()) return;
        this.$root.scrollUp();
        this.card.guid = uuidv4();
        await this.$store.direct.dispatch.iccalc.runPrecalc({
            card: this.card,
            providers: this.$store.direct.state.dicti.providers,
            guid: this.card.guid
        });
        console.log("runPrecalc end");

        this.initTimer();
    }
    destroyed() {
        this.$store.direct.commit.iccalc.disposeChecker();
    }

    cardHaveChanges(): boolean {
        //cardHaveChanged
        const cardToJson = DefaultCopy(
            this.$store.direct.state.insurance.card
        ) as InsuranceCard;
        cardToJson.guid = "";
        const cardJson = JSON.stringify(cardToJson);
        if (cardJson != this.$store.direct.state.iccalc.lastCardJson) {
            console.log("Обнаружены изменения в карте preCalcStates сброшены");
            this.$store.state.iccalc.preCalcStates = [];
            this.$store.state.iccalc.lastCardJson = cardJson;
            return true;
        } else {
            console.log("Изменений в карте не обнаружено, расчет отменен");
            this.$store.state.iccalc.lastCardJson = cardJson;
            return !this.$store.state.iccalc.preCalcStates?.length; //Не зачем повторять расчет по тем же данным, но только если расчёты есть
        }
    }

    //region timer
    timerId: any = null;
    time: number = 180;
    forceBadEnd: boolean = false;
    get isBadEnd() {
        if (this.forceBadEnd) return true;
        return (
            this.calcs.length &&
            this.calcs.every(x =>
                [CalcStatus.CalcFail, CalcStatus.NeedToSelectCar].includes(
                    x?.status
                )
            )
        );
    }
    initTimer() {
        this.timerId = setInterval(() => {
            if (this.time == 0) {
                clearInterval(this.timerId);
                this.time = null;
                const res = this.calcs.some(
                    x => x.status == CalcStatus.CalcSuccess
                );
                if (!res) this.forceBadEnd = true; //Успешних расчетов нет, времени нет, идем на экран конца
            } else this.time -= 1;
        }, 1000);
    }
    //endregion

    select(calc: CalcState) {
        this.$store.direct.commit.iccalc.setCurrentCalc(calc);
        console.log("selected calc", calc);
        this.$root.scrollUp();
        let provider = this.$store.direct.state.dicti.providers.find(
            x => x.code == calc.insuranceProviderId
        );
        sendPostMessageEvent(EventName.ApplyFastCalcIc, calc.insuranceProviderId);
        this.$router.push({ name: "stepper" });
    }
    get calcs(): CalcState[] {
        return sortCalcsByPriority(
            this.$store.direct.state.iccalc.preCalcStates,
            this.$store.direct.getters.priorityICSetting,
        );
    }
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    get getCardInfo(): string {
        let info = "";
        info += this.getMarkModelName + ", ";
        info += `${this.card.car.yearIssue}, `;
        info += `л.с. ${this.card.car.power}, `;

        if (this.card.drivers.length > 0) info += `${this.getDriversInfo}`;
        else {
            const owner = this.card.owner;
            info += `Собственник ${owner.surname} ${owner.name[0]} ${
                !!owner.patronymic ? owner.patronymic[0] : ""
            }, `;
        }
        info += this.card.owner.address.value;

        return info;
    }
    get getDriversInfo(): string {
        let info = "";
        this.card.drivers.forEach(x => {
            info += `${x.person.surname} ${x.person.name[0]}. ${
                !!x.person.patronymic ? x.person.patronymic[0] + "." : ""
            }, `;
        });
        return info;
    }
    get getMarkModelName() {
        const dic = this.$store.direct.state.dicti;
        const car = this.card.car;
        let mark = dic.mapMarks.find(x => x.id == car.markId)?.title ?? "";
        let model = dic.mapModels.find(x => x.id == car.modelId)?.title ?? "";
        return `${mark} ${model}`;
    }
    mounted() {
        GaHelper.send("prescoring");
    }
}
